import React from 'react';
import { useTranslation } from 'react-i18next';

import freshdeskPluginInstall from '../../assets/img/freshdesk-plugin-install.png';
import freshdeskPuzzle from '../../assets/img/freshdesk-puzzle.png';
import mobileDownload from '../../assets/img/mobile-download.png';
import googlePlay from '../../assets/img/google-play.png';
import appleStore from '../../assets/img/app-store.png';
import googlePlayLogo from '../../assets/img/google-play-logo.png';
import appleStoreLogo from '../../assets/img/app-store-logo.png';
import QRCodeWithLogo from '../ui/QRCodeWithLogo';


interface GetNowProps {
  licenseType: string;
  className?: string;
}

const GetNow: React.FC<GetNowProps> = ({ licenseType, className = '' }) => {
  const { t } = useTranslation();
  const googlePlayUrl = 'https://play.google.com/store/apps/details?id=de.deinconsultant.seller2go';
  const appleStoreUrl = 'https://apps.apple.com/de/app/seller2go/id6446055771';

  if (licenseType !== 'mobile' && licenseType !== 'freshdesk') {
    return null;
  }

  return (
    <div className={`get-now ${className}`}>
      <h2 className="block-title">{t(`${licenseType}.get_now_section.title`)}</h2>
      <div className="get-now-container">
        <div className="get-now-steps">
          {licenseType === 'mobile' && (
            <div className="get-now-step">
              <div className="get-now-step-content">
                <div className="get-now-step-content-inner">
                  <span className="get-now-step-text">
                    <h3 className="get-now-step-title">{t(`${licenseType}.get_now_section.card.title`)}</h3>
                    <p className="get-now-step-description">{t(`${licenseType}.get_now_section.card.description`)}</p>
                    <div className="get-now-step-images">
                      <a href={googlePlayUrl} target="_blank" rel="noopener noreferrer">
                        <img src={googlePlay} alt="Google Play" />
                      </a>
                      <a href={appleStoreUrl} target="_blank" rel="noopener noreferrer">
                        <img src={appleStore} alt="Apple Store" />
                      </a>
                    </div>
                  </span>
                </div>
                <div className="get-now-step-mobile-download">
                  <img src={mobileDownload} alt="Mobile Download" />
                </div>
              </div>
              <div className="get-now-step-right-side">
                <div className="qr-codes-container">
                  <div className="qr-code-item">
                    <QRCodeWithLogo
                      url={googlePlayUrl}
                      logo={googlePlayLogo}
                      size={180}
                      alt="Google Play QR Code"
                    />
                  </div>
                  <div className="qr-code-item">
                    <QRCodeWithLogo
                      url={appleStoreUrl}
                      logo={appleStoreLogo}
                      size={180}
                      alt="Apple Store QR Code"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {licenseType === 'freshdesk' && (
            <div className="get-now-step">
              <div className="get-now-step-content">
                <div className="get-now-step-content-inner">
                  <span className="get-now-step-text">
                    <h3 className="get-now-step-title">{t(`${licenseType}.get_now_section.card.title`)}</h3>
                    <p className="get-now-step-description">{t(`${licenseType}.get_now_section.card.description`)}</p>
                    {/* TODO: !!!!! what this button should do? */}
                    <button className="get-now-step-install-button" type="button">
                      {t(`${licenseType}.get_now_section.install_button`)}
                    </button>
                  </span>
                  <div className="get-now-step-plugin-install">
                    <img src={freshdeskPluginInstall} alt="Freshdesk Plugin Install" />
                  </div>
                </div>
              </div>
              <div className="get-now-step-right-side">
                <img src={freshdeskPuzzle} alt="Freshdesk Puzzle" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GetNow;
